import { Box, Grid } from '@material-ui/core';
import { ArrowBack, ArrowDownward, ArrowForward, ArrowUpward } from '@material-ui/icons';
import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { ScrollOrientation } from 'src/common/enumerations/scroll-orientation';
import VerticalCenter from 'src/vertical-center/vertical-center';
import { styles } from './pagination.styles';
import { ReactComponent as SvgAlternateArrowUpward } from './media/alternate-arrow-upward.svg';
import { ReactComponent as SvgAlternateArrowDownward } from './media/alternate-arrow-downward.svg';

interface IPaginationProps {
  currentPage: number;
  totalPages: number;
  updateCurrentPageHandler: Function;
  displayText?: boolean;
  testIdPrefix: string;
  canScrollUp?: boolean;
  canScrollDown?: boolean;
  scrollOrientation?: ScrollOrientation;
  sizeOverride?: string;
  useAlternateArrowDesign?: boolean;
}

export const Pagination: React.FC<IPaginationProps> = ({
  currentPage,
  totalPages,
  updateCurrentPageHandler,
  displayText = true,
  testIdPrefix,
  canScrollUp,
  canScrollDown,
  scrollOrientation = ScrollOrientation.Vertical,
  sizeOverride,
  useAlternateArrowDesign,
}): JSX.Element => {
  const classes = styles();

  if (canScrollUp === undefined && canScrollDown === undefined) {
    canScrollUp = !(currentPage <= 1);
    canScrollDown = !(currentPage === totalPages);
  }
  return totalPages > 1 ? (
    <React.Fragment>
      <Grid
        item
        style={{ height: sizeOverride } ?? {}}
        className={classes.navigationHeight}
        data-testid={`${testIdPrefix}-pagination-container`}
      >
        <VerticalCenter>
          <Grid item style={{ height: sizeOverride } ?? {}} className={classes.navigationButton}>
            <BaseButton
              data-testid={`${testIdPrefix}-pagination-previous-button`}
              disabled={!canScrollUp}
              buttonType='alternate'
              onClick={() => updateCurrentPageHandler(currentPage - 1)}
            >
              {scrollOrientation === ScrollOrientation.Vertical &&
                (useAlternateArrowDesign ? (
                  <SvgAlternateArrowUpward className={classes.arrowIcon} />
                ) : (
                  <ArrowUpward className={classes.arrowIcon} />
                ))}
              {scrollOrientation === ScrollOrientation.Horizontal && (
                <ArrowBack className={classes.arrowIcon} />
              )}
            </BaseButton>
          </Grid>
        </VerticalCenter>
      </Grid>
      {displayText && (
        <Grid item style={{ height: sizeOverride } ?? {}} className={classes.navigationHeight}>
          <VerticalCenter>
            <Box
              className={classes.navigationLabel}
              data-testid={`${testIdPrefix}-pagination-count`}
            >
              {currentPage} OF {totalPages}
            </Box>
          </VerticalCenter>
        </Grid>
      )}
      <Grid item style={{ height: sizeOverride } ?? {}} className={classes.navigationHeight}>
        <VerticalCenter>
          <Grid item style={{ height: sizeOverride } ?? {}} className={classes.navigationButton}>
            <BaseButton
              data-testid={`${testIdPrefix}-pagination-next-button`}
              disabled={!canScrollDown}
              buttonType='alternate'
              onClick={() => updateCurrentPageHandler(currentPage + 1)}
              className='nav-button'
            >
              {scrollOrientation === ScrollOrientation.Vertical &&
                (useAlternateArrowDesign ? (
                  <SvgAlternateArrowDownward className={classes.arrowIcon} />
                ) : (
                  <ArrowDownward className={classes.arrowIcon} />
                ))}
              {scrollOrientation === ScrollOrientation.Horizontal && (
                <ArrowForward className={classes.arrowIcon} />
              )}
            </BaseButton>
          </Grid>
        </VerticalCenter>
      </Grid>
    </React.Fragment>
  ) : (
    <></>
  );
};

export default Pagination;
